<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">404</h1>
            <h4 class="pt-3">{{ $t("errors.nopage") }}</h4>
            <p class="text-muted">{{ $t("errors.notfoundpage") }}</p>
          </div>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="fa fa-search"/>
              </b-input-group-text>
            </b-input-group-prepend>
            <input
              id="prependedInput"
              class="form-control"
              size="16"
              type="text"
              v-bind:placeholder="$t('errors.whatlooking')">
            <b-input-group-append>
              <b-button variant="info">{{ $t("buttons.search") }}</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import jwtMixin from '../../mixins/jwtMixin'

export default { name: 'Page404',
  mixins: [jwtMixin],
  created () {
    this.$i18n.locale = this.jwtLanguage()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/Page404.vue